import { queryOptions } from "@tanstack/react-query";
import api, { ApiCatalog } from "@/api";
import { type Features } from "./queries.types";

export const featuresQueries = {
  all: () =>
    queryOptions({
      queryKey: [ApiCatalog.feature.key, "me"] as const,
      queryFn: () => api().get<Features>(ApiCatalog.feature.endpoint),
    }),
  filter: (uniqueId: string) =>
    queryOptions({
      queryKey: [ApiCatalog.feature.key, uniqueId],
      queryFn: () =>
        api().get<Features>(ApiCatalog.feature.endpoint, {
          urlReplacers: [{ id: uniqueId }],
        }),
    }),
};

export default featuresQueries;
